export default __webpack_public_path__ + "static/media/LANDMARKS-ID-Logo.2a42b237.svg";